export default "__VITE_ASSET__01bb8924__"